/*Generated from the `:::slide{key="d2f8e263-7d5d-41ec-9f69-e63cd26b6e76" slug="strokes"}` (simplified/001/001/丨.mdx), `:::slide{key="4e5c2bc3-1617-46d2-b95b-40d61f1c8686" slug="stroke-names"}` (simplified/001/001/丨.mdx) directives, merged because they share one anchor. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, SvgGlyph, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!SvgGlyph) _missingMdxReference("SvgGlyph", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "7",
      children: _jsxs(html.p, {
        children: ["First, we'll learn about ", _jsx(html.strong, {
          children: "strokes",
          components: html
        }), "."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "7",
      children: _jsx(html.p, {
        children: "A stroke is a single, unbroken writing motion.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "7",
      children: _jsx(html.p, {
        children: "Every time you lift your pen or brush, it counts as one stroke.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "1",
      kind: "p",
      count: "7",
      children: _jsx(html.p, {
        children: "The simplest stroke is 丨.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "4",
      section: "1",
      kind: "SvgGlyph",
      count: "7",
      children: _jsx(SvgGlyph, {
        glyph: "丨",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "5",
      section: "1",
      kind: "p",
      count: "7",
      children: _jsx(html.p, {
        children: "In Haniverse, each stroke is given a unique name.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "6",
      section: "1",
      kind: "p",
      count: "7",
      children: _jsx(html.p, {
        children: "You'll find the name for 丨 on the next slide to practice in your reviews!",
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
